import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { getEnvConfig } from "./config/env.config";

let appInsights: ApplicationInsights | null = null;

export const initializeTelemetry = () => {
  const { applicationInsightsConnectionString } = getEnvConfig();

  if (appInsights || !applicationInsightsConnectionString) {
    return;
  }

  appInsights = new ApplicationInsights({
    config: {
      connectionString: applicationInsightsConnectionString,
      // Default App Insights sets ai_user and ai_session, which under TTDSG §25 need opt-in
      // consent and would put a banner in front of the front door.
      disableCookiesUsage: true,
      autoTrackPageVisitTime: true,
      enableAutoRouteTracking: true,
    },
  });
  appInsights.loadAppInsights();
};

export const getAppInsights = () => appInsights;
